/**
 * „Was ist neu".
 *
 * Nach dem Login einmal pro Nutzer und Version mit dem neuesten Eintrag;
 * die vollständige Historie über das Info-Icon in der Fußzeile.
 */

import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api';
import { useKora, useMeta } from '../zustand';
import { Modal } from '../komponenten/Modal';
import './changelog.css';

export function ChangelogModal({ alle }: { alle: boolean }) {
  const { modalSchliessen } = useKora();
  const meta = useMeta();
  const queryClient = useQueryClient();

  const bestaetigen = useMutation({
    mutationFn: () => api.sende('/profil/changelog-gesehen'),
    onSettled: () => {
      void queryClient.invalidateQueries({ queryKey: ['ich'] });
      modalSchliessen();
    },
  });

  const eintraege = alle ? meta.changelog : meta.changelog.slice(0, 1);

  function schliessen() {
    if (alle) modalSchliessen();
    else bestaetigen.mutate();
  }

  return (
    <Modal
      titel="Was ist neu"
      breite={540}
      abstandOben={64}
      onSchliessen={schliessen}
      kopfZusatz={
        <div className="cl-kopfmarke">
          {alle ? 'Versionshistorie' : `Neue Version ${meta.changelog[0]?.version ?? ''}`}
        </div>
      }
      fuss={
        <button type="button" className="cl-knopf" onClick={schliessen}>
          {alle ? 'Schließen' : 'Verstanden'}
        </button>
      }
    >
      {eintraege.map((c, i) => (
        <div className="cl-eintrag" key={c.version}>
          <div className="cl-kopf">
            <span
              className="cl-version"
              style={{ color: i === 0 && !alle ? 'var(--eh-rot)' : i === 0 ? 'var(--eh-rot)' : 'var(--eh-text-4)' }}
            >
              {c.version}
            </span>
            <span className="cl-datum">{c.datum}</span>
          </div>
          {c.punkte.map((p) => (
            <div className="cl-punkt" key={p}>
              <span className="cl-punkt-marke" />
              <span className="cl-punkt-text">{p}</span>
            </div>
          ))}
        </div>
      ))}
    </Modal>
  );
}
